"use strict";

require("core-js/modules/es.array.reduce.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (paths) {
  return paths.reduce(function (previous, path, index) {
    return "".concat(previous).concat(typeof path === 'string' ? "".concat(index > 0 ? '.' : '').concat(path) : "[".concat(path, "]"));
  }, '').toString();
};